export const sceneBars = `
    vec3 sceneBars(vec2 uv, float time) {
        uv.x += time * 0.05; float v=0.; 
        for(float i=0.; i<3.; i++) v+=smoothstep(.02,0.,abs(uv.y-sin(uv.x*2.+time+i)*.5));
        return vec3(.7,.4,.2)*(1.-abs(uv.y)) + vec3(v);
    }
`;
